const TitleAndDate = ({ title }) => {
  const today = new Date();
  const formattedDate = today.toLocaleDateString("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <div className="mt-6 mb-6">
      <h4 className="text-xl font-semibold mb-2">{title}</h4>
      <p>{formattedDate}</p>
    </div>
  );
};

export default TitleAndDate;
